import { useEffect, useState } from "react";
import { COLORS, Ic, ICONS } from "@/lib/theme";
import { apiGet } from "@/lib/api";
import BackHomeBar from "@/components/BackHomeBar";

export default function Times({ onHome }) {
  const [serviceType, setServiceType] = useState("weekday");
  const [data, setData] = useState({ weekday: [], shabbos: [], note: "" });
  useEffect(() => { apiGet("/services").then(setData).catch(() => {}); }, []);
  const list = serviceType === "weekday" ? data.weekday : data.shabbos;
  return (
    <div className="ls-scroll" data-testid="times-screen" style={{ paddingBottom: 100 }}>
      <BackHomeBar title="Times" onHome={onHome} />
      <div style={{ padding: "18px 22px 0" }}>
        <div className="font-heading" style={{ fontWeight: 800, fontSize: 26, color: COLORS.ink }}>Times · All Services</div>
        <div style={{ color: COLORS.muted, fontWeight: 600, fontSize: 13, marginTop: 4 }}>{data.note || "Confirm on the shul noticeboard."}</div>
      </div>
      <div style={{ padding: "18px 18px 0" }}>
        <label style={{ display: "block", fontWeight: 800, fontSize: 12, color: COLORS.purple, margin: "0 4px 7px" }}>SERVICE SCHEDULE</label>
        <select data-testid="times-service-dropdown" value={serviceType} onChange={(e) => setServiceType(e.target.value)} className="ls-input" style={{ fontWeight: 800, color: COLORS.ink, background: "#fff" }}>
          <option value="weekday">Weekday Services</option>
          <option value="shabbos">Shabbos & Friday Services</option>
        </select>
        <div className="ls-card" data-testid="times-list" style={{ padding: 6, marginTop: 12 }}>
          {list.map((s, i) => <div key={s.name} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 14px", borderBottom: i < list.length - 1 ? "1px solid #f0ebf4" : "none" }}>
            <span style={{ fontWeight: 700, fontSize: 15 }}>{s.name}</span><span className="font-heading" style={{ fontWeight: 800, fontSize: 18, color: COLORS.purple }}>{s.time}</span>
          </div>)}
        </div>
        <div className="ls-card" style={{ marginTop: 16, padding: 16, background: COLORS.lilac, border: "none", display: "flex", gap: 12, alignItems: "center" }}>
          <Ic d={ICONS.info} color={COLORS.plum} /><span style={{ fontSize: 13, fontWeight: 600, color: COLORS.ink }}>{serviceType === "shabbos" ? "Shabbos services are led by our Rabbinic Couple, with our renowned music and singing." : "Weekday minyanim daven with warmth, devotion and community spirit."}</span>
        </div>
      </div>
    </div>
  );
}
